'use client';
import Script from "next/script";
import { useEffect } from "react";
declare global {
    interface Window {
        EasebuzzCheckout: any;
    }
}

export default function PaymentComponent({ operationType, redirectLink, onPaymentDone, notification }: any) {

    useEffect(() => {
        if (
            operationType === "EASEBUZZ_PAYMENT_LINK" &&
            redirectLink &&
            window.EasebuzzCheckout
        ) {
            const env = process.env.NEXT_PUBLIC_ENDPOINT === "production" ? "prod" : "test";

            const easebuzzCheckout = new window.EasebuzzCheckout(
                redirectLink,
                env
            );

            const options = {
                access_key: redirectLink,
                pay_mode: env,
                onResponse: (data: any) => {
                    console.log("[Easebuzz] Payment response:", JSON.stringify(data));
                    if (data && data.status === "success") {
                        notification("success", "Payment successful");
                        onPaymentDone(true);
                    } else {
                        notification("error", "Payment failed or was cancelled");
                        onPaymentDone(false);
                    }
                },
                onClose: () => {
                    console.log("[Easebuzz] Payment window closed by user");
                    onPaymentDone(false);
                }
            };

            easebuzzCheckout.initiatePayment(options);
        }
    }, [operationType]);

    return (
        <>
            <Script
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/easebuzz-checkout.js"
                strategy="afterInteractive"
                onLoad={() => {
                    console.log("[Easebuzz] Script loaded");
                }}
                onError={() => {
                    console.error("[Easebuzz] Failed to load script");
                    notification("error", "Failed to load payment gateway. Please try again.");
                }}
            />
        </>
    );
}
